"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountGroupChart = void 0;
const ChartType_1 = __importDefault(require("@opsbase/lib-chart/ChartType"));
const QueryFieldRegistry_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldRegistry"));
const useDimensions_1 = __importDefault(require("@opsbase/react-hooks/useDimensions"));
const Bar2D_1 = __importDefault(require("@opsbase/web-charts/Bar2D"));
const MouseEnterDatumMutation_1 = __importDefault(require("@opsbase/web-charts/helpers/MouseEnterDatumMutation"));
const MouseLeaveDatumMutation_1 = __importDefault(require("@opsbase/web-charts/helpers/MouseLeaveDatumMutation"));
const Pie2D_1 = __importDefault(require("@opsbase/web-charts/Pie2D"));
const react_1 = __importStar(require("react"));
const ChartPane_1 = __importDefault(require("../ChartPane"));
const useCountGroupData_1 = __importDefault(require("./useCountGroupData"));
function CountGroupChart({ chart, width, height, fontSize, highlightXId, onClickValue, }) {
    const dimension = QueryFieldRegistry_1.default[chart.config.dimension];
    const { loading, data } = (0, useCountGroupData_1.default)(dimension.key);
    const [paneRef, paneDims] = (0, useDimensions_1.default)();
    // Handle Click and Mouseover
    const onClickDatum = (0, react_1.useCallback)((e, v) => {
        const d = v.datum || v.data[0];
        onClickValue({ v: d.y, x: d.xDim });
    }, [onClickValue]);
    const onMouseEnterDatum = (0, react_1.useCallback)(() => MouseEnterDatumMutation_1.default, []);
    const onMouseLeaveDatum = (0, react_1.useCallback)(() => MouseLeaveDatumMutation_1.default, []);
    // Update Chart
    const chartBit = (0, react_1.useMemo)(() => {
        if (loading || !data || !(data === null || data === void 0 ? void 0 : data.length) || !paneDims)
            return null;
        // Highlighted data
        if (highlightXId) {
            data.forEach(datum => {
                datum.opacity = datum.xDim.id === highlightXId ? 1 : 0.2;
            });
        }
        // Create Chart
        let chartProps = Object.assign({ width: paneDims.width, height: paneDims.height, data, fontSize: fontSize }, (!!onClickValue ? { onClickDatum, onMouseEnterDatum, onMouseLeaveDatum } : {}));
        if (chart.chartType === ChartType_1.default.BAR2D)
            return react_1.default.createElement(Bar2D_1.default, Object.assign({}, chartProps));
        if (chart.chartType === ChartType_1.default.PIE2D)
            return react_1.default.createElement(Pie2D_1.default, Object.assign({}, chartProps));
    }, [
        loading,
        data,
        paneDims,
        highlightXId,
        fontSize,
        onClickValue,
        onClickDatum,
        onMouseEnterDatum,
        onMouseLeaveDatum,
        chart.chartType,
    ]);
    return (0, react_1.useMemo)(() => (react_1.default.createElement(ChartPane_1.default, { ref: paneRef, loading: loading, width: width, height: height }, chartBit)), [paneRef, loading, width, height, chartBit]);
}
exports.CountGroupChart = CountGroupChart;
exports.default = CountGroupChart;
